module.exports = __webpack_public_path__ + "img/187.8211cb84.jpg";